import { ChatSessionLabel } from "@ext/agent/components/panel/ChatSessionLabel";
import type { ChatSearchFragment, ChatSearchResult } from "@ext/agent/components/search/chatSearchResults";
import t from "@ext/localization/locale/translate";
import { SearchMarkedText } from "@ext/serach/components/results/SearchMarkedText";
import { SearchResultRow } from "@ext/serach/components/results/SearchResultRow";
import { DropdownMenuEmptyItem, DropdownMenuItem } from "@ui-kit/Dropdown";

const ITEM_CLASS = "h-auto rounded-md p-0 hover:bg-secondary-bg-hover focus:bg-secondary-bg-hover";

export type ChatSearchResultListProps = {
	results: ChatSearchResult[];
	isPending: boolean;
	isFailed: boolean;
	onOpenSession: (id: string) => void;
	onOpenMessage: (id: string, fragment: ChatSearchFragment) => void;
};

export const ChatSearchResultList = ({
	results,
	isPending,
	isFailed,
	onOpenSession,
	onOpenMessage,
}: ChatSearchResultListProps) => {
	if (isFailed) return <DropdownMenuEmptyItem>{t("app.error.command-failed.title")}</DropdownMenuEmptyItem>;

	if (results.length === 0 && !isPending)
		return <DropdownMenuEmptyItem>{t("agent.search.not-found")}</DropdownMenuEmptyItem>;

	return results.map((result) => (
		<div className="py-1" key={result.id}>
			<DropdownMenuItem className={ITEM_CLASS} onSelect={() => onOpenSession(result.id)}>
				<div className="flex w-full min-w-0 items-center gap-2 px-2 pt-2 pb-1 text-xs font-normal text-primary-fg">
					<ChatSessionLabel
						createdAt={result.createdAt}
						title={result.title}
						titleMarks={result.titleMarks}
					/>
				</div>
			</DropdownMenuItem>
			{result.fragments.length > 0 && (
				<div className="ml-2.5 border-l border-secondary-border pl-1">
					{result.fragments.map((fragment) => (
						<DropdownMenuItem
							className={ITEM_CLASS}
							key={fragment.ts}
							onSelect={() => onOpenMessage(result.id, fragment)}
						>
							<SearchResultRow className="w-full min-w-0 px-2 py-0.5 text-[11px] leading-4">
								<SearchMarkedText marks={fragment.marks} />
							</SearchResultRow>
						</DropdownMenuItem>
					))}
				</div>
			)}
		</div>
	));
};
